<template>
  <div class="site">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/index' }">数据概览</el-breadcrumb-item>
      <el-breadcrumb-item>基础设置</el-breadcrumb-item>
      <el-breadcrumb-item>Webscoket设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <el-form ref="formRef" :model="form" label-width="150px">
        <el-form-item label="WebScoket地址">
          <el-input v-model="form.wsaddress"></el-input>
        </el-form-item>
        <el-form-item label="WebScoket端口号">
          <el-input v-model="form.wsport"></el-input>
        </el-form-item>
        <el-form-item label="最大接待人数">
          <el-input v-model="form.maxnum"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Webscoket',
  data () {
    return {
      form: {
        wsaddress: '',
        wsport: '',
        maxnum: ''
      }
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    // 获取信息
    async getInfo () {
      const { data: res } = await this.$http.get('ws')
      if (res.status === 200) {
        this.form.wsaddress = res.data.wsaddress
        this.form.wsport = res.data.wsport
        this.form.maxnum = res.data.maxnum
      } else {
        this.$message.error(res.msg)
      }
    },
    // 提交表单
    async onSubmit () {
      const { data: res } = await this.$http.post('ws', this.form)
      if (res.status === 200) {
        this.$message.success(res.msg)
        this.$refs.formRef.resetFields()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>

</style>
